<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">
  	  <div class="backborder3"> 
	      <el-transfer style="text-align: left; display: inline-block" v-model="mycustomer" filterable :data="defaultcustomer" :titles="['系统客户', '我的客户']"></el-transfer>
		  <el-form style="margin-top:20px">
	          <el-form-item label="一键移交销售员">
	              <el-select v-model="localclerkid" filterable remote style="width:15%" @change="getchangeclerk()">
				      <el-option v-for="(item,index) in allclerks" :key="index" :label="item.name" :value="item.id"></el-option>
				  </el-select> 
	          </el-form-item>
		  </el-form>		    
		  <div slot="footer" class="dialog-footer" style="text-align:right;margin-top:10px">
	    	  <el-button size="small" type="primary" @click="editclerkcustomer" :loading="editclerkLoading">确 定</el-button>
	      </div>
      </div>
  </div>
  </transition>
</template>

<script>

export default {
  props:['childdata'],
  data () {
    return {
      actionauth:'', //操作权限
      transitionshow:true,
      url:this.GLOBAL.domain+"Clerk/index",
      clerkid:'',
      clerkname:'',
      localclerkid:'',
      localclerkname:'',
      defaultcustomer:[],
      mycustomer:[],
      editclerkLoading:false,
      allclerks:[],
      
    }
  },
  mounted(){
      this.getactionauth();
      this.changecustomer(); //获取职员负责的客户信息
      this.getallclerks(); //职员信息列表
  },
  methods:{  
  
  	/** 获取操作权限 **/
  	getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
    
    changecustomer() {
    	this.clerkid=this.childdata.id;
    	this.clerkname=this.childdata.name;
    	this.localclerkid=this.childdata.id;
    	this.localclerkname=this.childdata.name;
    	
    	var resource = this.$resource(this.url);
        resource.query({ act:'getclerkcustomer',id:this.clerkid,token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            var customers = JSON.parse(Base64.decode(res.data.Data));
	            this.defaultcustomer=customers.default;
	            this.mycustomer=customers.my;
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    /** 获取当前代理商所有的职员 **/
    getallclerks() {
   		var resource = this.$resource(this.url);
    	resource.query({ act:'getallclerks',token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.allclerks = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },
    
    /** 更换职员信息 **/
    getchangeclerk() {
    	var clerkid=this.localclerkid;
    	var _this=this;
    	this.allclerks.forEach(function(item,i) {
    		if(clerkid==item.id) _this.localclerkname=item.name;
    	});
    },
    
    /** 保存职员的客户 **/
    editclerkcustomer() {
    	this.editclerkLoading=true;
    	if(this.clerkid==this.localclerkid) { //当前职员编辑客户信息
    		var resource = this.$resource(this.url);
	    	resource.save({ act:'changecustomer',oid:this.clerkid,nid:this.localclerkid,customerids:this.mycustomer,token:this.$cookies.get('token')}).then((res) => {
		        if(res.data.Result>0){
		            if(res.data.Result=='70001') this.$router.push('/login')
		            this.$message.error(res.data.Message);
		        }else{
		            this.editclerkLoading=false;
		            this.$message.success('配对客户成功');
		            this.$emit('closechild','Clerkcustomer'); //关闭窗口
		        }
	        }).catch((res) => {
	            
	        });
    		
    	}else { //职员客户信息移交给新的职员
    		this.$confirm('您是否确认将职员：'+this.clerkname+'手里的全部客户信息移交给职员：'+this.localclerkname+'，继续?', '提示', { type: 'warning' }).then(() => {
				var resource = this.$resource(this.url);
		    	resource.save({ act:'changecustomer',oid:this.clerkid,nid:this.localclerkid,customerids:this.mycustomer,token:this.$cookies.get('token')}).then((res) => {
			        if(res.data.Result>0){
			            if(res.data.Result=='70001') this.$router.push('/login')
			            this.$message.error(res.data.Message);
			        }else{
			            this.editclerkLoading=false;
			            this.$message.success('配对客户成功');
			            this.$emit('closechild','Clerkcustomer'); //关闭窗口
			        }
		        }).catch((res) => {
		            this.editclerkLoading=false;
		        });
				
	        }).catch(() => {
	            this.$message.info('已取消操作!');
	            this.editclerkLoading=false;
	        });
    		
    	}
    },

  }
}
</script>
<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder3 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 3% 1%}
.el-transfer-panel {width:300px}
</style>


// WEBPACK FOOTER //
// src/components/base/Clerkcustomer.vue